import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Skrivebord',
    component: () => import('./views/Skrivebord.vue')
  }
]

export default routes
